import "./feedbackUser.css"

import askIcon from "../../img/icons/ask.png"

export const FeedbackUsers = () => {
    return (
        <>
            <div className="container-feedback">
                <div className="feedback-title-container">
                    <img src={askIcon} alt="ask" className="ask-icon" />
                    <h4 className="feedback-title">Feedback</h4>
                </div>
                <div className="">
                    <hr />
                    <iframe width="640px" height="480px" src="https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAYAAP3G1DBUM0hHVlJZVDZJVjZHN0RRMUM1WDM1NDFBTC4u&embed=true" frameborder="0" marginwidth="0" marginheight="0" allowfullscreen webkitallowfullscreen mozallowfullscreen msallowfullscreen className="form-style-feedback"> </iframe>
                </div>
            </div>
        </>
    )
}